import React, { useEffect, useState } from "react";
import configData from "../config.json";
import { useNavigate } from "react-router-dom";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./LoginScreen.css";
import axios from "axios";
import { getToken } from "../utils/auth";

function LoginScreen() {
  const navigate = useNavigate();
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const [retailers, setRetailers] = useState([]); // Store the retailer data
  const [selectedRetailer, setSelectedRetailer] = useState(null); // Selected retailer ID
  const [branches, setBranches] = useState([]); // Branches for the selected retailer
  const [selectedBranch, setSelectedBranch] = useState(null); // Selected branch ID

  useEffect(() => {
    // Fetch data from API
    const fetchData = async () => {
      const token = getToken()
      const headers = {
        "Content-Type": "application/json",
        "x-access-token": token,
      };
      try {
        const response = await axios.get(`${configData.SERVER_URL}/RetailersInfo`, { headers });
        console.log(response.data);
        setRetailers(response.data);
        if (response.data.length > 0) {
          const initialRetailer = response.data[0];
          setSelectedRetailer(initialRetailer.retailer_id);
          setBranches(initialRetailer.branches);
          if (initialRetailer.branches.length > 0) {
            setSelectedBranch(initialRetailer.branches[0].branch_id);
          }
        }
      } catch (error) {
        console.error("Error fetching retailer data:", error);
        notify(error, "error");
      }
    };
    fetchData();
  }, []);

  const handleLoginClick = () => {
    if (selectedBranch !== null && selectedRetailer !== null) {
      navigate(`/Home/${selectedRetailer}/${selectedBranch}`);
    } else {
      console.log("the selected is null");
    }
  };

  // Handle retailer selection change
  const handleRetailerChange = (event) => {
    const retailerId = parseInt(event.target.value, 10);
    setSelectedRetailer(retailerId);

    const selectedRetailerData = retailers.find(
      (r) => r.retailer_id === retailerId
    );
    if (selectedRetailerData) {
      setBranches(selectedRetailerData.branches);
      if (selectedRetailerData.branches.length > 0) {
        setSelectedBranch(selectedRetailerData.branches[0].branch_id);
      } else {
        setSelectedBranch(null);
      }
    }
  };
  // Handle branch selection change
  const handleBranchChange = (event) => {
    setSelectedBranch(event.target.value);
  };

  return (
    <div className="retailer-branches-login-container">
      <div className="retailer-branches-login-form">
        <h1 className="retailer-branches-login-header">Select Store</h1>

        {/* Retailer Dropdown */}
        <div className="retailer-branches-input-group">
          <label htmlFor="retailer" className="retailer-branches-label">
            Select Retailer
          </label>
          <select
            id="retailer"
            value={selectedRetailer || ""}
            onChange={handleRetailerChange}
            className="retailer-branches-input"
          >
            {retailers.map((retailer) => (
              <option key={retailer.retailer_id} value={retailer.retailer_id}>
                {`${retailer.retailer_name} - ${retailer.retailer_id}`}
              </option>
            ))}
          </select>
        </div>

        {/* Branch Dropdown */}
        <div className="retailer-branches-input-group">
          <label htmlFor="branch" className="retailer-branches-label">
            Select Branch
          </label>
          <select
            id="branch"
            value={selectedBranch || ""}
            onChange={handleBranchChange}
            className="retailer-branches-input"
            disabled={branches.length === 0}
          >
            <option value="" disabled>
              Select a branch
            </option>
            {branches.map((branch) => (
              <option key={branch.branch_id} value={branch.branch_id}>
                {`${branch.branch_name} - ${branch.branch_id}`}
              </option>
            ))}
          </select>
        </div>

        <button
          className="retailer-branches-login-btn"
          disabled={!selectedBranch}
          onClick={handleLoginClick}
        >
          Connect
        </button>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default LoginScreen;
